import { StyleSheet, Dimensions } from 'react-native';

import { SEPARATOR_STROKE, SIZES, PALETTE, MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;



export default MediaQueryStyleSheet.create({
  container: {
    flex: 1,
  },
  tabletView: {
    flex: 1,
  },

  dateSummary: {

    padding: 5,
    marginHorizontal: 5,
    marginTop: 5,

    flex: 0,
    flexDirection: 'row',
    borderColor: PALETTE.primaryStrokeLine,
    borderWidth: 1,
    backgroundColor: 'transparent',

  },

  DateSelectionBar: {
    paddingHorizontal: 10,
    minHeight: 40,
    marginVertical: 10,
    marginTop: 30,
  },

  currentSelection: {
    flex: 3,
    textAlign: 'center',

  },

  selectionText: {
    fontSize: 12,
  },


  timeline: {
    height: 60,
    paddingTop: 20,
    paddingBottom: 0,

    paddingLeft: 10,
    paddingRight: 10

  },

  summaryText: {
    paddingLeft: 20,

  },


  groupSelection: {
    paddingTop: 20,
    marginBottom: 10,
    // borderTopWidth: 1,
    // borderTopColor: PALETTE.primaryStrokeLine,
  },


  noPadding: {
    padding: 0
  },

  seperator: {
    marginHorizontal: 0
  },

  valueheader: {
    marginHorizontal: SIZES.appHorizontalSpace,
    paddingTop: 4,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },

  chart: {
    paddingLeft: 10,
    justifyContent: 'space-between',
    marginVertical: 15,
    minHeight: 250,
  },


  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
  },


  rowTopBorder: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
    borderTopWidth: 1,
    borderTopColor: PALETTE.primaryStrokeLine,

  },

  notice: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 20
  },


  rowSummary: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
  },



  rowRight: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },


  valueItem: {
    paddingRight: 10
  },

  rowBorder: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
    paddingBottom: 30,
    paddingTop: 15
  },


}, {
    [MQ_TABLET]: {
      mainWrapper: {
        width: WINDOW_WIDTH * 0.92,
        flexDirection: 'row',
        alignSelf: 'center',
        //marginTop:30,
        paddingBottom: 30,
        justifyContent: 'center',
      },
      leftWrapper: {
        width: WINDOW_WIDTH * 0.50,
        minHeight: WINDOW_HEIGHT * 0.7,
        alignSelf: 'flex-start',
        flexDirection: 'row',
        paddingRight: 20,
      },
      rightWrapper: {
        width: WINDOW_WIDTH * 0.42,
      },
      subItems: {
      },
      groupSelection: {
        borderTopWidth: 0,
      },
      tabletView: {
        flex: 1,
      },

    }
  });
